module.exports = __webpack_public_path__ + "img/snowmaking_overnight-rq3n6Wj.svg";